import React from 'react'
import {useIntl} from 'react-intl'
import {PageTitle} from '../../../_metronic/layout/core'
import {Navigate, Route, Routes} from 'react-router-dom'
import {DemandeDemontageListPage} from './DemandeDemontageListPage'
import {DemandeDemontageRealisation} from './pages/DemandeDemontageRealisation'
import {DemandeDemontageHistoriquePage} from './DemandeDemontageHistoriquePage'

const DemandeDemontageWrapper = () => {
  const intl = useIntl()
  return (
    <>
      <Routes>
        <Route
          path='/liste'
          element={
            <>
              <PageTitle breadcrumbs={[]}>Demande de démontage</PageTitle>
              <DemandeDemontageListPage />
            </>
          }
        />
        <Route
          path=':demandeDemontageId/realisation/:vehiculeId'
          element={
            <>
              <PageTitle breadcrumbs={[
                {
                  title: 'Demande de démontage', path: '/demande-demontage/liste', isSeparator: false, isActive: true
                }
              ]}>Réalisation</PageTitle>
              <DemandeDemontageRealisation />
            </>
          }
        />
        <Route
          path='/:demandeDemontageId/historique'
          element={
            <>
              <PageTitle breadcrumbs={[
                {
                  title: 'Demandes de démontage', path: '/demande-demontage/liste', isSeparator: false, isActive: true,
                },
              ]}>Historique demande de démontage</PageTitle>
              <DemandeDemontageHistoriquePage />
            </>
          }
        />

        <Route index element={<Navigate to='/demande-demontage/liste' />} />
      </Routes>
    </>
  )
}

export {DemandeDemontageWrapper}
